import React, { useState } from "react";
import user_img_1 from "../../assets/images//User.png";
import arrowSvg from "../../assets/images/down_arrow_icon_2.svg";
import checkIcon from "../../assets/images/check_icon.svg";

const SelectCommonModal = ({
  title = "Please Select",
  data = [],
  labelKey = "name",
  valueKey = "id",
  imageKey = null,
  isMultiple = false,
  onClose,
  onApply,
  filterInactive = false,
}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [open, setOpen] = useState(false);

  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

  const filteredData = data;

  // ✅ FIXED toggle logic
  const handleSelect = (item) => {
    if (item.isActive === false) return;

    if (!isMultiple) {
      setSelectedItem(item);
      setOpen(false);
      return;
    }

    const exists = selectedItems.some(
      (i) => String(i[valueKey]) === String(item[valueKey])
    );

    setSelectedItems((prev) =>
      exists
        ? prev.filter(
          (i) => String(i[valueKey]) !== String(item[valueKey])
        ) // remove
        : [...prev, item] // add
    );
  };

  const removeItem = (value) => {
    if (!isMultiple) {
      setSelectedItem(null);
      return;
    }

    setSelectedItems((prev) =>
      prev.filter((i) => String(i[valueKey]) !== String(value))
    );
  };

  const isApplyDisabled = isMultiple == true
    ? selectedItems.length === 0
    : !selectedItem;

  const pluralizeTitle = (title) => {
    const words = title.split(" ");
    const lastWord = words[words.length - 1].toLowerCase();

    let pluralLastWord = lastWord;

    switch (lastWord) {
      case "client":
        pluralLastWord = "clients";
        break;
      case "company":
        pluralLastWord = "companies";
        break;
      case "employee":
        pluralLastWord = "employees";
        break;
      default:
        pluralLastWord = lastWord + "s";
    }

    words[words.length - 1] = pluralLastWord;
    return words.join(" ");
  };

  return (
    <div className="modal_overlay">
      <div className="modal_box">
        <h3>{title}</h3>

        <div
          className={`custom_select ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <span className="placeholder">
            {isMultiple ? pluralizeTitle(title) : title}
          </span>

          <img
            src={arrowSvg}
            alt="arrow"
            className="dropdown_arrow"
          />

          {open && (
            <div className="dropdown_list">
              {filteredData.map((item) => {
                const selected = isMultiple
                  ? selectedItems.some(
                    (i) =>
                      String(i[valueKey]) ===
                      String(item[valueKey])
                  )
                  : selectedItem &&
                  String(selectedItem[valueKey]) ===
                  String(item[valueKey]);

                return (
                  <div
                    key={item[valueKey]}
                    className={`dropdown_item ${selected ? "selected" : ""} ${item.isActive === false ? "disabled" : ""
                      }`}
                    onClick={() => handleSelect(item)}
                  >
                    {imageKey && (
                      <img
                        className="company_logo"
                        src={
                          item[imageKey]
                            ? BASE_URL + item[imageKey]
                            : user_img_1
                        }
                        alt=""
                      />
                    )}

                    <span className="company_name">
                      {item[labelKey]}
                    </span>

                    <span className={`status-badge-blue small ${item.isActive !== false ? "active" : "inactive"}`}>
                      {item.isActive !== false ? "Active" : "Inactive"}
                    </span>

                    {selected && (
                      <img
                        src={checkIcon}
                        alt="selected"
                        className="tick_mark"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="selected_container">
          {isMultiple ? (
            selectedItems.map((item) => (
              <div
                key={item[valueKey]}
                className="selected_chip"
              >
                {imageKey && (
                  <img
                    className="company_logo"
                    src={
                      item[imageKey]
                        ? BASE_URL + item[imageKey]
                        : user_img_1
                    }
                    alt=""
                  />
                )}
                <span>{item[labelKey]}</span>
                <span className={`status-badge-blue small ${item.isActive !== false ? "active" : "inactive"}`}>
                  {item.isActive !== false ? "Active" : "Inactive"}
                </span>
                <button
                  onClick={() =>
                    removeItem(item[valueKey])
                  }
                >
                  ×
                </button>
              </div>
            ))
          ) : (
            selectedItem && (
              <div
                key={selectedItem[valueKey]}
                className="selected_chip"
              >
                {imageKey && (
                  <img
                    className="company_logo"
                    src={
                      selectedItem[imageKey]
                        ? BASE_URL + selectedItem[imageKey]
                        : user_img_1
                    }
                    alt=""
                  />
                )}
                <span>{selectedItem[labelKey]}</span>
                <button
                  onClick={() =>
                    removeItem(selectedItem[valueKey])
                  }
                >
                  ×
                </button>
              </div>
            )
          )}
        </div>

        <div className="modal_actions">
          <button className="btn_cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn_apply"
            disabled={isApplyDisabled}
            onClick={() =>
              onApply(
                isMultiple ? selectedItems : selectedItem
              )
            }
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectCommonModal;
